<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="padding: 10px;">
          <div class="actionBarStyle">
            <el-row style="display: flex;align-items: center;">
              <div class="searchStyle" style="font-size: 16px;">
                活动管理
              </div>
            </el-row>
            <el-row>
              <el-button type="primary" round @click="editCompetitionGroup()">添加分组奖项</el-button>
            </el-row>
          </div>
        </div>

        <div style="padding: 10px;">
          <div>活动基本信息</div>
          <div style="display: flex;">
            <div>活动名称：</div>
            <div>{{competition.title}}</div>
          </div>

          <div style="display: flex;">
            <div>活动类别：</div>
            <div>{{competition.category}}</div>
          </div>

          <div style="display: flex;">
            <div>活动时间：</div>
            <div>{{competition.start_time}}~{{competition.end_time}}</div>
          </div>

        </div>

        <div style="padding: 10px;">
          <div>活动奖品</div>

          <div v-if="awards && awards.length>0">
            <div v-for="(item,index) in awards">
              <div style="display: flex;">
                <div>活动分组：</div>
                <div>{{item.award_group_name}}</div>
              </div>

              <div style="display: flex;">
                <div>奖品名称：</div>
                <div>xxxx</div>
              </div>

              <div style="display: flex;">
                <div>奖品缩图：</div>
                <div>xxxx</div>
              </div>

            </div>
          </div>
          <div v-esle>
            暂未添加...
          </div>



        </div>

      </el-col>
    </el-row>


  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    created() {
      this.competition_id = this.$route.params.competition_id

      this.username = this.$session.get('USERNAME') // 获取session
      this.loadData()
    },
    mounted() {
      this.username = this.$session.get('USERNAME') // 获取session
    },
    data() {
      return {
        username: '',
        competition_id: '',
        competition: '',
        awards: []
      }
    },
    methods: {

      loadData() {
        console.log('加载数据')
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_load_competition_detail.jsp'
        this.axios.get(requestUrl, {
            params: {
              competition_id: that.competition_id
            }
          }).then(function(response) {


            that.competition = response.data.competition

            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })
      },
      loadAwards() {
        console.log('加载数据')
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_load_competition_awards.jsp'
        this.axios.get(requestUrl, {
            params: {
              competition_id: that.competition_id
            }
          }).then(function(response) {


            that.awards = response.data.awards

            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })
      },
      editCompetitionGroup() {
        this.$router.push({
          name: 'competition_group_edit',
          params: {
            competition_id: this.competition_id,
          }
        })
      },
      delCompetition(index, rows) {
        let cid = rows[index].id
        let that = this

        this.$confirm('确定要删除吗?', '操作提醒', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 开启loading
          const load = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          var requestUrl = '/score/web/_competition_delete.jsp'
          this.axios.get(requestUrl, {
            params: {
              competition_id: cid
            }
          }).then(function(response) {
            console.log(response)

            that.$message.success('删除成功！！')


            load.close()

            that.loadData('', '')

          }).catch(function(error) {
            console.log(error)
            load.close()
          })
        }).catch(() => {

        })

      },
      manageCompetition(index, rows) {

      },
      getImageUrl(image_name) {
        return '/score' + image_name
      },

      indexMethod(index) {
        return index + 1
      },
      indexSysMethod(index) {
        return index + 1
      },
      setCurrent(row) {
        this.$refs.multipleTable.setCurrentRow(row)
      },
      upgrade(index, rows) {
        let courseName = rows[index].course_name
        let that = this

        this.show_selection = true

        this.new_position = index
        if (index > 0) {
          this.new_position = index - 1
        }

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_move_course_position.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username,
              course: courseName,
              direction: 'UPGRADE'
            }
          }).then(function(response) {
            that.tableData = response.data
            that.currentItems = that.tableData
            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })
      },
      downgrade(index, rows) {
        let courseName = rows[index].course_name
        let that = this

        this.show_selection = true

        this.new_position = index
        if (index < this.currentItems.length - 1) {
          this.new_position = index + 1
        }

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_move_course_position.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username,
              course: courseName,
              direction: 'DOWNGRADE'
            }
          }).then(function(response) {
            that.tableData = response.data
            that.currentItems = that.tableData
            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })
      },
      deleteSelectedCourses() {
        let that = this
        let courses = this.$refs.multipleTable.selection
        let coursesJsonStr = JSON.stringify(courses)

        this.msg = '要删除选中的科目名称吗？'

        this.$confirm(this.msg, '重要提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {
            courses: coursesJsonStr,
            username: that.username
          }

          that.show_selection = false

          var qs = require('qs')

          // 开启loading
          const load = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          var requestUrl = '/score/web/_delete_muti_courses.jsp'

          this.axios.post(
              requestUrl,
              qs.stringify(data), {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
              }
            ).then(function(response) {
              that.loadData('', '')
              load.close()
            })
            .catch(function(error) {
              console.log(error)
              load.close()
            })
        })
      }
    }
  }
</script>

<style>
  .searchStyle {
    display: flex;
    width: 200px;
    align-items: center;

  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/components/competition_manager.vue